// @flow

import LoadingScreen from './src/LoadingScreen';
import LoadingScreenReducer from './src/LoadingScreenReducer';
import * as LoadingScreenActions from './src/LoadingScreenActions';

export type { LoadingScreenReducerType } from './src/LoadingScreenReducer';

export {
    LoadingScreen as default,
    LoadingScreenReducer,
    LoadingScreenActions,
};



// WEBPACK FOOTER //
// ./node_modules/@adactive/arc-loading-screen/index.js